/**
 * Open a new browser tab with the URL in parameter
 *
 * @param {String} url
 * @returns {void}
 */
export default function redirectToWeb(url) {
  window.open(url, "_blank")
}
